module.exports = __webpack_public_path__ + "img/PXL_20230524_111243216.b358b49c.jpg";